import { browserCheck } from '@ta-interaktiv/browsercheck'
import { maxDays } from '../globalConfig'
import React from 'react'
export const isMobile: boolean = browserCheck.isMobile

export const limitAdditionalCountries = 1000
// ABSTAND DER AKTUELLEN VERDOPPLUNGSKURVE ZUM AKTUELLEN PUNKT
export const doublingOffset = 10
// ANZAHL DER CHARTS IN EINER ZEILE
export const colCount = isMobile ? 2 : 8
// MAXIMALE LÄNDERANZAHL VOR DEM AUFKLAPPEN ALLER LÄNDER
export const maxCountryCount = isMobile ? 18 : 16
// X UND Y VERSATZ DER BESCHRIFTUNG DER HORIZONTALEN HILFSLINIEN
export const horiTickTextOffset = { x: 5, y: 12 }
// SCHRITTE AUF DER X-ACHSE IN TAGEN
export const xScaleSteps = 15
// PUNKT AUF VERDOPPLUNGSKURVE FÜR MARKER - GEZÄHLT VOM LETZTEN
export const dMarkerPoint = 16
// MOVING AVERAGE
export const averageOverXDays = 5
// COLUMN-SPACING
export const graphColSpace = isMobile ? 10 : 15
export const graphXStart = isMobile ? 1 : 1
// CHART-CONFIG
export const casesSetup = {
  yRange: [0, isMobile ? 150 : 190],
  yDomain: [100, 8000000],
  xDomain: [0, maxDays],
  yTicks: {
    lines: [100, 1000, 10000, 100000, 1000000, 8000000],
    text: [1000, 10000, 100000, 1000000, 8000000]
  }
}
export const newInfectionsSetup = {
  yRange: [78, 0],
  yDomain: [100000, 1],
  xDomain: [0, maxDays],
  yTicks: {
    lines: [1, 100, 1000, 10000, 100000],
    text: [100, 1000, 10000, 100000]
  }
}
export const deathsSetup = {
  yRange: [68, 0],
  yDomain: [10000, 1],
  xDomain: [0, maxDays],
  yTicks: {
    lines: [1, 100, 1000, 10000],
    text: [100, 1000, 10000]
  }
}
